const itineraryList = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_ITINERARY_LIST':
            return action.itineraryList
        default:
            return state
    }
}

export default itineraryList
